/**Import react section */
import React from 'react'
import propTypes from 'prop-types'

/** Material UI import section */
import {
    Button,
    Typography
} from '@material-ui/core';

import {ButtonCreateStyles} from '../../../../resources/styles/ButtonCreateStyles'

const ButtonSaved =(props)=> {
    const {isSaving, onSavedClick, title} = props;
    const classes = ButtonCreateStyles();
    const onButtonSavedClick = ()=>{
        if(onSavedClick){
            onSavedClick()
        }
    }

    return (
        <Button
            variant="contained"
            size="small"
            disabled={isSaving}
            className={classes.btnSaved}
            onClick={onButtonSavedClick}
        >
             <Typography variant="subtitle2">{title}</Typography>
        </Button>
    )
}

ButtonSaved.propTypes = {
    /**Confirm the operation to be performed*/
    onSavedClick: propTypes.func.isRequired,
    /**Determinate if saving an operation */
    isSaving: propTypes.bool,
    /**Determinate el title of button */
    title: propTypes.string.isRequired,
}

ButtonSaved.defaultProps = {
    isSaving: false,
    title: '',
    onSavedClick: () =>
        console.warn('Callback [onSavedClick] no defined'),

}

export default ButtonSaved
